import {
	applyAaaServerFilter,
	focusAaaServer,
	openAaaServerSection,
} from './adapter';
import {
	openAaaServerCreateModal,
	openAaaServerDeleteModal,
	openAaaServerEditModal,
} from './modal';
import {resolveAaaServers} from './resolver';

/**
 * AAA Server profiles.
 *
 * The reference resolver was already here, so an SSID could name its
 * AAA Server. This adds the section itself: reaching it, finding a
 * server by name, and opening its Add, Edit or Delete form.
 *
 * Declares no fields, deliberately. The table carries the
 * authentication and accounting passphrases, and the resolver is
 * written not to expose server configuration - neither the agent nor
 * anything it retains should hold them.
 */
const aaaServerPlugin = {
	id: 'aaa_server',
	version: 1,
	commandVersion: 1,
	resource: 'aaa_server',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.aaa_servers': openAaaServerSection,
	},
	resolvers: {
		aaa_server: resolveAaaServers,
	},
	filters: {
		aaa_server: (command) => applyAaaServerFilter(command.params?.query),
	},
	focusHandlers: {
		aaa_server: (command) => focusAaaServer(command.params?.entity_id),
	},
	modals: {
		'aaa_server.create': openAaaServerCreateModal,
		'aaa_server.edit': openAaaServerEditModal,
		'aaa_server.delete': openAaaServerDeleteModal,
	},
};

export default aaaServerPlugin;
